import { render, staticRenderFns } from "./HomeAside.vue?vue&type=template&id=95dc3b62&scoped=true"
import script from "./HomeAside.vue?vue&type=script&lang=js"
export * from "./HomeAside.vue?vue&type=script&lang=js"
import style0 from "./HomeAside.vue?vue&type=style&index=0&id=95dc3b62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95dc3b62",
  null
  
)

export default component.exports